import { FILTER_DROPDOWN_SIZES, FILTER_FIELD_BROKER } from '../consts';
import { FilterItem, SearchCheckboxFilterDropdown } from '../SearchCheckboxFilterDropdown';

interface BrokerFilterDropdownProps {
  items: FilterItem<string>[];
  selectedBrokers: string[];
  onApply: (values: string[]) => void;
  onClose: () => void;
}

export const BrokerFilterDropdown = ({ items, selectedBrokers, onApply, onClose }: BrokerFilterDropdownProps) => (
  <SearchCheckboxFilterDropdown
    variant="compact"
    size={FILTER_DROPDOWN_SIZES[FILTER_FIELD_BROKER]}
    items={items}
    selectedValues={selectedBrokers}
    onApply={onApply}
    onClose={onClose}
    selectAllLabel="Все брокеры"
  />
);
